<template>
  <div>
    <vs-button @click="popupActive=true" color="primary" icon-pack="feather" icon="icon-plus">プロット登録</vs-button>

    <vs-popup id="enterprise-plot-select" title="プロットカテゴリー" :active.sync="popupActive">
      <vs-row>
        <vs-col
          vs-w="6"
          class="plot-category"
          v-for="(category, index) in topCategory"
          :key="index">
          <vs-button class="plot-button" color="primary" type="flat" @click="onSelectPlot(category.id)">
            <img
              :src="getSrc(category.img)"
              class="icon-large"
            />
            <p class="plot-title">{{ category.label }}</p>
            <div class="plot-comment">{{ category.comment }}</div>
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col
          vs-w="3"
          class="plot-category"
          v-for="(plotChildCategory, index) in childCategory"
          :key="index">
          <vs-button class="plot-button" color="primary" type="flat" @click="onSelectPlot(plotChildCategory.id)">
            <img
              :src="getSrc(plotChildCategory.img)"
              class="icon-small"
            />
            <p class="plot-title">{{ plotChildCategory.label }}</p>
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>

// モジュール
import _ from 'lodash';
import {mapState} from "vuex";
import {
  PLOT_PARENT_CATEGORY,
  PLOT_CHILD_CATEGORY
} from "@/config/const";

// mixins
import {PlotMixin} from "@/mixins";

export default {
  components: {
    ...mapState({
      PLOT_CHILD_CATEGORY: () => PLOT_CHILD_CATEGORY
    }),
  },
  mixins: [PlotMixin],
  props: {},
  data() {
    return {
      popupActive: false,
      topCategory: null,
      childCategory: null
    }
  },
  created() {
    this.setTopCategory();
    this.childCategory = _.transform(
      PLOT_CHILD_CATEGORY.properties,
      (result, value) => {
        if (this.isChildCategory(value)) {
          result[value.id] = value;
        }
      },
    );
  },
  beforeDestroy() {
    this.popupActive = false;
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    onSelectPlot(id) {
      this.$vs.loading()
      setTimeout(() => {

        this.$vs.loading.close()
        this.popupActive = false;

        this.$router.push({
          name: "enterprise-plot-edit",
          params: {child_category: id}
        })
      }, 500);

    },
    getSrc(img) {
      return require("@/assets/images/plot/" + img + ".png");
    },
    isChildCategory(childCategory) {
      return childCategory.id !== PLOT_CHILD_CATEGORY.CONSTRUCTION &&
        childCategory.id !== PLOT_CHILD_CATEGORY.RESTRICTION
    },
    setTopCategory() {
      this.topCategory = [
        PlotMixin.methods.getParentCategoryProps(PLOT_PARENT_CATEGORY.CONSTRUCTION),
        PlotMixin.methods.getParentCategoryProps(PLOT_PARENT_CATEGORY.RESTRICTION)
      ]
    }
  }
}

</script>

<style lang="sass">
#enterprise-plot-select

  .vs-popup--title
    > h3
      font-weight: bold

  .plot-button
    color: #333333

  .plot-category
    text-align: center

  .icon-large
    width: 70px
    height: 70px
    margin: 0.5rem auto

  .icon-small
    width: 45px
    height: 45px
    margin: 0.5rem auto

  .plot-title
    font-size: 1.2rem
    font-weight: bold

  .plot-comment
    font-size: 1rem

</style>
